import { graphql } from "react-relay";

export const fragments = {
  payload: graphql`
    fragment SuggestionActionFyi_payload on SuggestionActionFyiPayload {
      nop
    }
  `,
};
